import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, IconButton, Spinner } from "@radix-ui/themes";
import { Controller, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { RootState } from "../../../redux/store";
import { routes } from "../../../routes";
import { changePassword } from "../../../services/user/changePassword";
import { ChangePasswordFormValidation } from "./ChangePasswordFormValidation";
import { EyeOpenIcon, EyeClosedIcon } from "@radix-ui/react-icons";

type FormValues = {
  userId: string;
  newPassword: string;
  oldPassword: string;
  confirmPassword: string;
};



export const ChangePassword = () => {
  const userData = useSelector((state: RootState) => state.login.userData);
  const mutation = useMutation({
    mutationFn: changePassword,
    mutationKey: "changePassword",
  });
  const [validationSchema, setValidationSchema] = useState<any>(null);

  useEffect(() => {
    const loadSchema = async () => {
      const schema = await ChangePasswordFormValidation();
      setValidationSchema(schema);
    };
    loadSchema();
  }, []);

  const defaultValues: FormValues = {
    userId: userData.UserId,
    newPassword: "",
    oldPassword: "",
    confirmPassword: "",
  };

  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
    defaultValues,
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Senha do utilizador actualizada com sucesso!");
        navigate(routes.dashboard);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

 
  const [showOld, setShowOld] = useState(false);
const [showNew, setShowNew] = useState(false);
const [showConfirm, setShowConfirm] = useState(false);


  const handleBack = () => {
    navigate(routes.dashboard);
  };

  return (
    <Card size="3">
      <form onSubmit={onSubmit} noValidate>
        <Controller
          name="userId"
          control={control}
          render={({ field }) => <input type="hidden" {...field} />}
        />
        <Flex direction="column" gap="4">
           <div style={{ position: "relative", width: "100%" }}>
          <TextFieldComponent
            name="oldPassword"
            label="Senha antiga"
            control={control}
            errors={errors}
            
    fieldProps={{ placeholder: "Senha antiga", type: showOld ? "text" : "password" }}
          />
            <IconButton
                type="button"
                variant="ghost"
                color="gray"
                aria-label={showOld ? "Ocultar senha antiga" : "Mostrar senha antiga"}
                onClick={() => setShowOld((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "var(--space-3)",
                  top: "var(--space-6)",
                }}
              >
                {showOld ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </IconButton>
          </div>

         
            <div style={{ position: "relative", width: "100%" }}>
              <TextFieldComponent
                name="newPassword"
                label="Senha nova"
                control={control}
                errors={errors}
                 fieldProps={{ placeholder: "Senha nova", type: showNew ? "text" : "password" }}
              />

              <IconButton
                type="button"
                variant="ghost"
                color="gray"
                aria-label={showNew ? "Ocultar senha nova" : "Mostrar senha nova"}
                onClick={() => setShowNew((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "var(--space-3)",
                  top: "var(--space-6)",
                }}
              >
                  {showNew ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </IconButton>
              </div>
               <div style={{ position: "relative", width: "100%" }}>
              <TextFieldComponent
                name="confirmPassword"
                label="Confirmar senha"
                control={control}
                errors={errors}
                  fieldProps={{ placeholder: "Confirmar senha", type: showConfirm ? "text" : "password" }}
              />
              <IconButton
                type="button"
                variant="ghost"
                color="gray"
                aria-label={showConfirm ? "Ocultar confirmação da senha" : "Mostrar confirmação da senha"}
                onClick={() => setShowConfirm((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "var(--space-3)",
                  top: "var(--space-6)",
                }}
              >
                {showConfirm ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </IconButton>
            </div>
          

          <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? (
                <Spinner loading>
                  {" "}
                  <EnterIcon />
                </Spinner>
              ) : (
                <EnterIcon />
              )}
              Actualizar
            </Button>
          </Flex>
        </Flex>
      </form>
    </Card>
  );
};
